import React, { PropTypes } from 'react';
import DropdownMenu from 'common/components/dropdown_menu';
import partial from 'lodash/partial';

const Menu = ({ isLoggedIn, isCreative, isClient, hasOpenProjects, creative, invite, router }) => {
  const buttons = [{
    label: "Invite to work",
    action: () => {},
    toggleOnClick: true,
    closeOnClick: false,
    extraBtnClasses: "btn btn-primary",
    show: !isLoggedIn || isClient,
  }, {
    label: <span>Invite <span className="username">{creative.username}</span> to your project</span>,
    action: () => invite(creative),
    extraBtnClasses: "btn btn-primary",
    show: isClient && hasOpenProjects,
  }, {
    action: () => router.push(`/start-a-project/start-1-1/?one_to_one_creative=${creative.username}`),
    label: <span>Work directly with <span className="username">{creative.username}</span></span>,
    extraBtnClasses: "btn btn-primary",
    show: !isLoggedIn || isClient,
  }];

  return (
    <DropdownMenu buttons={buttons} className="creative-dropdown-menu with-buttons"
      showFirst={true} />
  );
};

Menu.propTypes = {
  isLoggedIn: PropTypes.bool,
  isCreative: PropTypes.bool,
  isClient: PropTypes.bool,
  hasOpenProjects: PropTypes.bool,
  creative: PropTypes.object,
  invite: PropTypes.func,
};

export default Menu;
